import React from "react";
import { HintView } from "lib/components/index";

const Hint = () => (
  <HintView.Hint>
    <p>{I18n.t("papp.products.EditProductView.StepPricedFields.hint.p1")}</p>

    <p>
      <strong>{I18n.t("papp.products.EditProductView.StepPricedFields.hint.p2a")}</strong> -{" "}
      {I18n.t("papp.products.EditProductView.StepPricedFields.hint.p2b")}
    </p>
    <p>
      <strong>{I18n.t("papp.products.EditProductView.StepPricedFields.hint.p3a")}</strong> -{" "}
      {I18n.t("papp.products.EditProductView.StepPricedFields.hint.p3b")}
    </p>
    <p>
      <strong>{I18n.t("papp.products.EditProductView.StepPricedFields.hint.p4a")}</strong> -{" "}
      {I18n.t("papp.products.EditProductView.StepPricedFields.hint.p4b")}
    </p>

    <p>{I18n.t("papp.products.EditProductView.StepPricedFields.hint.p5")}</p>

    <h3>{I18n.t("papp.products.EditProductView.StepPricedFields.hint.p6")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepPricedFields.hint.p7")}</p>

    <h3>{I18n.t("papp.products.EditProductView.StepPricedFields.hint.p8")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepPricedFields.hint.p9")}</p>
  </HintView.Hint>
);

export default Hint;



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepPricedFields/StepPricedFieldsHint.jsx